import { render, staticRenderFns } from "./ActionsMenuInvite.vue?vue&type=template&id=6221a9f0&"
import script from "./ActionsMenuInvite.vue?vue&type=script&lang=js&"
export * from "./ActionsMenuInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports